/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyStockReportDTO
 */
export interface DailyStockReportDTO {
    /**
     * 
     * @type {number}
     * @memberof DailyStockReportDTO
     */
    hours?: number;
    /**
     * 
     * @type {string}
     * @memberof DailyStockReportDTO
     */
    warehouse?: string;
}

/**
 * Check if a given object implements the DailyStockReportDTO interface.
 */
export function instanceOfDailyStockReportDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DailyStockReportDTOFromJSON(json: any): DailyStockReportDTO {
    return DailyStockReportDTOFromJSONTyped(json, false);
}

export function DailyStockReportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyStockReportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hours': !exists(json, 'hours') ? undefined : json['hours'],
        'warehouse': !exists(json, 'warehouse') ? undefined : json['warehouse'],
    };
}

export function DailyStockReportDTOToJSON(value?: DailyStockReportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hours': value.hours,
        'warehouse': value.warehouse,
    };
}

